export interface IPrePpWlForm {
    applicantTitle: IPrePpWlFormField;
    applicantFirstName: IPrePpWlFormField;
    applicantSurname: IPrePpWlFormField;
    applicantPhoneNumber: IPrePpWlFormField;
    applicantEmail: IPrePpWlFormField;
    applicantCompany: IPrePpWlFormField;
    applicantPostcode: IPrePpWlFormField;
    applicantAddress: IPrePpWlFormField;
    applicantPostTown: IPrePpWlFormField;
    applicantAddressLine1: IPrePpWlFormField;
    applicantAddressLine2: IPrePpWlFormField;
    applicantAddressLine3: IPrePpWlFormField;
    applicantUprn: IPrePpWlFormField;
    applicantEasting: IPrePpWlFormField;
    applicantNorthing: IPrePpWlFormField;
    // Agent details
    agentTitle: IPrePpWlFormField;
    agentFirstName: IPrePpWlFormField;
    agentSurname: IPrePpWlFormField;
    agentPhoneNumber: IPrePpWlFormField;
    agentEmail: IPrePpWlFormField;
    agentCompany: IPrePpWlFormField;
    agentPostcode: IPrePpWlFormField;
    agentAddress: IPrePpWlFormField;
    agentAddressLine1: IPrePpWlFormField;
    agentAddressLine2: IPrePpWlFormField;
    agentAddressLine3: IPrePpWlFormField;
    agentUprn: IPrePpWlFormField;
    agentPostTown: IPrePpWlFormField;
    agentEasting: IPrePpWlFormField;
    agentNorthing: IPrePpWlFormField;
    // Description of development
    typeOfDevelopment: IPrePpWlFormField<typeof PrePpWlDescriptionOfDevelopmentDevelopmentTypes[keyof typeof PrePpWlDescriptionOfDevelopmentDevelopmentTypes]>;
    developmentScale: IPrePpWlFormField;
    // Type of development
    // 1)Extension
    alterationWidth: IPrePpWlFormField;
    alterationLength: IPrePpWlFormField;
    alterationHeightToEaves: IPrePpWlFormField;
    alterationHeight: IPrePpWlFormField;
    otherAlterationOrExtensionSpecified: IPrePpWlFormField;
    // 2) New Dwellings
    totalNumberOfUnitsProposed: IPrePpWlFormField;
    typeOfNewBuild: IPrePpWlFormField;
    // 3) Retail, Office, Industrial
    additionalGrossFloorSpace: IPrePpWlFormField;
    additionalFullTimeEmployees: IPrePpWlFormField;
    additionalPartTimeEmployees: IPrePpWlFormField;
    estimatedNumberOfVehicularTrips: IPrePpWlFormField;
    nonResidentialChangeOfUse: IPrePpWlFormField<typeof PrePpWlNonResidentialChangeOfUseTypes[keyof typeof PrePpWlNonResidentialChangeOfUseTypes]>;
    alterationsDescription: IPrePpWlFormField;
    //4) Other
    otherDevelopmentDescription: IPrePpWlFormField;

    //Site Details
    currentUseOfTheSite: IPrePpWlFormField;
    proposalAffectsAnyTrees: IPrePpWlFormField;
    siteLocationIsSameAsApplicant: IPrePpWlFormField<boolean>;
    siteLocationAddress: IPrePpWlFormField;
    siteLocationAddressLine1: IPrePpWlFormField;
    siteLocationAddressLine2: IPrePpWlFormField;
    siteLocationAddressLine3: IPrePpWlFormField;
    siteLocationUprn: IPrePpWlFormField;
    siteLocationEasting: IPrePpWlFormField;
    siteLocationNorthing: IPrePpWlFormField;
    siteLocationPostTown: IPrePpWlFormField;
    siteLocationPostcode: IPrePpWlFormField;

    // Stage
    enquiryStage: IPrePpWlFormField;

    // Additional Information
    hardCopySiteLocationPlansWillBeProvided: IPrePpWlFormField<boolean>;
    blockPlanProvided: IPrePpWlFormField<boolean>;
    existingDetailsProvided: IPrePpWlFormField<boolean>;
    proposedDetailsProvided: IPrePpWlFormField<boolean>;
    photographsProvided: IPrePpWlFormField<boolean>;
    designStatementProvided: IPrePpWlFormField<boolean>;
    hardCopyOptionalDocumentsWillBeProvided: IPrePpWlFormField<boolean>;
    otherInformation: IPrePpWlFormField;
    siteLocationDocuments: IPrePpWlFormField<Array<File>>;
    optionalDocuments: IPrePpWlFormField<Array<File>>;

    // Fees
    feeAmount: IPrePpWlFormField;
    isCustomFee: IPrePpWlFormField<boolean>;
    feeMessage: IPrePpWlFormField;
}

export const PrePpWlFormKeyToLabel = {
    applicantTitle: "Title",
    applicantFirstName: "First Name",
    applicantSurname: "Surname",
    applicantPhoneNumber: "Phone Number",
    applicantEmail: "Email",
    applicantCompany: "Company",
    applicantPostcode: "Postcode",
    applicantAddress: "Address",
    applicantPostTown: "Post Town",
    applicantAddressLine1: "Address Line 1",
    applicantAddressLine2: "Address Line 2",
    applicantAddressLine3: "Address Line 3",
    applicantUprn: "UPRN",
    applicantEasting: "Easting",
    applicantNorthing: "Northing",
    agentTitle: "Title",
    agentFirstName: "First Name",
    agentSurname: "Surname",
    agentPhoneNumber: "Phone Number",
    agentEmail: "Email",
    agentCompany: "Company",
    agentPostcode: "Postcode",
    agentAddress: "Address",
    agentAddressLine1: "Address Line 1",
    agentAddressLine2: "Address Line 2",
    agentAddressLine3: "Address Line 3",
    agentUprn: "UPRN",
    agentPostTown: "Post Town",
    agentEasting: "Easting",
    agentNorthing: "Northing",
    typeOfDevelopment: "Type of Development",
    developmentScale: "Development Scale",
    alterationWidth: "Width (m)",
    alterationLength: "Length (m)",
    alterationHeightToEaves: "Height to Eaves (m)",
    alterationHeight: "Height (m)",
    otherAlterationOrExtensionSpecified: "Other alteration or extension specified",
    totalNumberOfUnitsProposed: "Total number of units proposed",
    typeOfNewBuild: "Type of new build",
    additionalGrossFloorSpace: "Additional gross floor space (sq m)",
    additionalFullTimeEmployees: "Number of additional full time employees, if any",
    additionalPartTimeEmployees: "Number of additional part time employees, if any",
    estimatedNumberOfVehicularTrips: "Estimated number of vehicular trips per week to and from the proposed development (e.g. customers, employees, and deliveries)",
    nonResidentialChangeOfUse: "Non Residential Change of Use",
    alterationsDescription: "Briefly describe the alteration(s)",
    otherDevelopmentDescription: "Other development (e.g. solar panels). Please specify",
    currentUseOfTheSite: "Current use of the site",
    proposalAffectsAnyTrees: "Proposal affects any trees",
    siteLocationIsSameAsApplicant: "Site location is same as applicant",
    siteLocationAddress: "Address",
    siteLocationAddressLine1: "Address Line 1",
    siteLocationAddressLine2: "Address Line 2",
    siteLocationAddressLine3: "Address Line 3",
    siteLocationUprn: "UPRN",
    siteLocationEasting: "Easting",
    siteLocationNorthing: "Northing",
    siteLocationPostTown: "Post Town",
    siteLocationPostcode: "Postcode",
    enquiryStage: "Enquiry Stage",
    hardCopySiteLocationPlansWillBeProvided: "I will provide a hard copy of the Site Location Plan",
    blockPlanProvided: "Block plan provided",
    existingDetailsProvided: "Existing details provided",
    proposedDetailsProvided: "Proposed details provided",
    photographsProvided: "Photographs provided",
    designStatementProvided: "Design statement provided",
    hardCopyOptionalDocumentsWillBeProvided: "I will provide hard copy of these files",
    otherInformation: "Any other information",
    siteLocationDocuments: "If you have a digital Site Location Plan, please upload the file(s) here",
    optionalDocuments: "If any of these are digital files, please upload the them here",
    feeAmount: "Fee Amount (£)",
    isCustomFee: "Is Custom Fee",
    feeMessage: "Message",
} as const;

export interface IPrePpWlFormField<Value = string> {
    value: Value;
    errorMsg: string;
}

// DO NOT CHANGE VALUES FOR BELOW CONSTANTS - IT IS MAPPED WITH VALUES ON INTERNAL SYSTEM

export const PrePpWlDescriptionOfDevelopmentDevelopmentTypes = {
    ALTERATIONS_EXTENSIONS: "Make alterations or extensions to an existing house",
    NEW_DWELLINGS: "Build new dwellings",
    RETAIL_OFFICE_INDUSTRIAL: "Retail/office/industrial development",
    OTHER: "Any other type of development (e.g. solar panels)",
} as const;
export const PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes = {
    EXTENSION: "Extension (e.g. conservatory)",
    OUTBUILDING: "Outbuilding (e.g. garage, shed)",
    OTHER: "Other (e.g. solar panels)",
} as const;
export const PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes = {
    EXTENSION: "Extension",
    NEW_BUILD: "New Build",
    CHANGE_OF_USE: "Change of use (e.g. residential to retail)",
    ALTERATIONS: "Alterations (e.g. shop fronts, pv panels, fences)",
} as const;
export const PrePpWlTypeOfBuildDevelopmentTypes = {
    NEW_BUILD: "New Build",
    CONVERSION: "Conversion (e.g. house into flats)",
} as const;
export const PrePpWlNonResidentialChangeOfUseTypes = {
    UNDER_1000: "under1000",
    OVER_1000: "over1000",
} as const;
export const PrePpWlTypeOfNewBuildDevelopmentTypes = {
    FLAT: "Flat",
    HOUSE: "House",
    BUNGALOW: "Bungalow",
    MIXED: "Mixed",
} as const;
export const PrePpWlTypeOfOtherDevelopmentTypes = {
    VARIATION_OR_REMOVAL_OF_CONDITION: "Variation or removal of a condition",
    ADVERTISEMENTS: "Advertisements",
    NON_HOUSEHOLDER_LISTED_BUILDING_CONSENT: "Non-householder listed building consent",
    OTHER: "Other",
} as const;

export const PrePpWlEnquiryStages = {
    PRINCIPLE: "Stage 1 (Principle)",
    DETAILED_DESIGN_AND_LAYOUT: "Stage 2 (Detailed Design And Layout)",
} as const;

export type PrePpWlServiceLevel =
    | typeof PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes[keyof typeof PrePpWlDescriptionOfDevelopmentAlterationDevelopmentTypes]
    | typeof PrePpWlTypeOfBuildDevelopmentTypes[keyof typeof PrePpWlTypeOfBuildDevelopmentTypes]
    | typeof PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes[keyof typeof PrePpWlTypeOfRetailOfficeIndustrialDevelopmentTypes]
    | typeof PrePpWlTypeOfOtherDevelopmentTypes[keyof typeof PrePpWlTypeOfOtherDevelopmentTypes];
